<template>
  <component :is="renderComponent" :key="renderKey" />
</template>

<script>
import { mapGetters } from 'vuex'
import { menu, menuAll } from '@/api/api'
import { attachNavMeta, resolveRenderMode, RENDER_COMPONENT_MAP } from '@/utils/cmsNav'

import CmsSectionPage from './cms/CmsSectionPage.vue'
import CmsEmptyView from './cms/placeholders/CmsEmptyView.vue'
import VocationalPage from './vocational.vue'
import ConstructPage from './construct.vue'
import InvestorPage from './investor.vue'
import CopyrightPage from './copyright.vue'

export default {
  name: 'CmsPage',
  components: {
    CmsEmptyView,
    CmsSectionPage,
    VocationalPage,
    ConstructPage,
    InvestorPage,
    CopyrightPage,
  },
  data() {
    return {
      parentNavItem: null,
      activeSubMenu: null,
      ready: false,
    }
  },
  computed: {
    ...mapGetters(['locale']),
    query() {
      return this.$route.query || {}
    },
    renderMode() {
      if (!this.ready) return 'empty'
      const navType = this.parentNavItem && this.parentNavItem.navMeta
        ? this.parentNavItem.navMeta.navType
        : 'menu'
      return resolveRenderMode(this.activeSubMenu, {
        singleId: this.query.singleId,
        contentId: this.query.contentId,
        businessId: this.query.id,
        navType,
      })
    },
    renderComponent() {
      return RENDER_COMPONENT_MAP[this.renderMode] || 'CmsEmptyView'
    },
    renderKey() {
      // 子菜单切换由页面内部处理，key 不含 menuId，避免整页销毁重建
      const parts = [
        this.renderComponent,
        this.query.parentId,
        this.query.id,
        this.query.contentId,
        this.query.singleId,
        this.query.search,
      ]
      return parts.filter((item) => item !== undefined && item !== null && item !== '').join('-')
    },
  },
  watch: {
    $route(to, from) {
      if (this.isSubMenuOnlyChange(to, from)) {
        this.updateActiveSubMenu(to.query.parentId, to.query.menuId)
        return
      }
      this.bootstrap()
    },
    locale() {
      this.bootstrap()
    },
  },
  created() {
    this.bootstrap()
    this.$bus.$on('localeChanged', this.bootstrap)
  },
  beforeDestroy() {
    this.$bus.$off('localeChanged', this.bootstrap)
  },
  methods: {
    isSubMenuOnlyChange(to, from) {
      if (!to || !from) return false
      if (to.path !== '/cms' || from.path !== '/cms') return false
      if (String(to.query.parentId || '') !== String(from.query.parentId || '')) return false
      if (String(to.query.menuId || '') === String(from.query.menuId || '')) return false
      const contextKeys = ['id', 'contentId', 'singleId', 'search']
      return contextKeys.every((key) => String(to.query[key] || '') === String(from.query[key] || ''))
    },
    async updateActiveSubMenu(parentId, menuId) {
      if (!parentId || !menuId) return
      try {
        const subRes = await menu(parentId)
        const subList = subRes.data || []
        this.activeSubMenu = subList.find((item) => String(item.menuId) === String(menuId)) || null
      } catch (e) {
        this.activeSubMenu = null
      }
    },
    async bootstrap() {
      const parentId = this.query.parentId
      const menuId = this.query.menuId
      const onlySubMenuChange = this.ready &&
        String(parentId || '') === String(this._lastParentId || '') &&
        !this.query.singleId &&
        !this.query.contentId &&
        !this.query.id

      if (!onlySubMenuChange) {
        this.ready = false
      }

      if (this.query.singleId) {
        this.parentNavItem = null
        this.activeSubMenu = null
        this.ready = true
        return
      }

      if (parentId) {
        try {
          const navRes = await menuAll(true)
          const navList = (navRes.data || []).map(attachNavMeta)
          this.parentNavItem = navList.find((item) => String(item.menuId) === String(parentId)) || null

          if (menuId) {
            const subRes = await menu(parentId)
            const subList = subRes.data || []
            this.activeSubMenu = subList.find((item) => String(item.menuId) === String(menuId)) || null
          } else {
            this.activeSubMenu = null
          }
        } catch (e) {
          this.parentNavItem = null
          this.activeSubMenu = null
        }
      } else if (this.query.id) {
        this.parentNavItem = null
        this.activeSubMenu = null
      } else {
        this.parentNavItem = null
        this.activeSubMenu = null
      }

      this._lastParentId = parentId
      this.ready = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/CmsPage.vue